import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry.ts";
import { logger } from "./lib/logger.ts";
import App from "./App.tsx";
import { initializeIframeBridge } from "./lib/walletProviderProxy.ts";

import "./index.css";

initSentry();

// Initialize wallet provider bridge for iframes
// This allows Rainbow and other wallets that don't inject into iframes to be proxied from parent window
if (window.self !== window.top) {
  const params = new URLSearchParams(window.location.search);
  const embed = params.get("embed") === "true";

  if (embed) {
    // Get parent origin from document.referrer (secure)
    // Fallback to production domain if referrer not available
    let parentOrigin = "https://deposit.paywithglide.xyz";

    if (document.referrer) {
      try {
        parentOrigin = new URL(document.referrer).origin;
      } catch (e) {
        logger.error(`Failed to parse document.referrer: ${e}`);
      }
    }

    initializeIframeBridge(parentOrigin);
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
